import { roles } from 'common-src/models/Client';
import { TaskType } from 'common-src/models/PatientTask/constants';

export const BASE_MINUTES = {
  [TaskType.ScheduleVisit.value]: 12,
  [TaskType.RescheduleVisit.value]: 12,
  [TaskType.BillingAndInsurance.value]: 18,
  [TaskType.MemberPortal.value]: 8,
  [TaskType.Engagement.value]: 12,
  [TaskType.CareCoordinationCaregiverOutreach.value]: 12,
  [TaskType.Cognitive.value]: 45,
  [TaskType.Compliance.value]: 10,
  [TaskType.AthenaIntegration.value]: 10,
  [TaskType.Labs.value]: 15,
  [TaskType.SocialWorkReferral.value]: 15,
  [TaskType.CareCoordination.value]: 15,
  [TaskType.Administrative.value]: 20,
  [TaskType.BGM.value]: 30,
  [TaskType.CGM.value]: 30,
  [TaskType.StarRatings.value]: 30,
  [TaskType.Diabetes.value]: 30,
  [TaskType.GUIDE.value]: 30,
};

export const DEFAULT_BASE_MINUTES = null;

export const ROLE_FACTOR = {
  [roles.System.label]: 0.1,
  [roles.Admin.label]: 1.0,
  [roles.Viewer.label]: 1.0,
  [roles.MXSpecialist.label]: 1.0,
  [roles.CareNavigator.label]: 1.0,
  [roles.Enrollment.label]: 1.0,
  [roles.AccountabilityCoach.label]: 1.0,
  [roles.RN.label]: 1.1,
  [roles.CDE.label]: 1.1,
  [roles.RD.label]: 1.1,
  [roles.SocialWorker.label]: 1.1,
  [roles.RCM.label]: 1.2,
  [roles.NP.label]: 1.2,
  [roles.Physician.label]: 1.3,
  [roles.ExternalPhysician.label]: 1.3,
  [roles.Neurologist.label]: 1.3,
  [roles.NPNeurologist.label]: 1.3,
};

export const DEFAULT_ROLE_FACTOR = 1.0;

export const WORKING_DAYS_PER_WEEK = 5;
